import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TableHead,
  TableRow,
  TableCell,
  Box,
  ListItemText,
  MenuItem,
  Tooltip,
} from '@mui/material'

import { MoreVert } from '@mui/icons-material'
import { TableMenuComponent } from '@/views/components'
import { IconButtonBg } from '@/theme/icon-button.theme'

type Props = {
  type: 'product' | 'wagerType' | 'sport'
  handleOnClickSetEnable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDisable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
}
const HeadTableRestrictions = ({
  type,
  handleOnClickSetDisable,
  handleOnClickSetEnable,
}: Props) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleSelectAll = () => {
    handleOnClickSetEnable(type, 'ALL', true)
  }

  const handleUnselectAll = () => {
    handleOnClickSetDisable(type, 'ALL', true)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: 150, minWidth: 150 }}>
          <strong>
            {type === 'product'
              ? t('restrictions.product')
              : type === 'wagerType'
              ? t('restrictions.wagerType')
              : t('restrictions.sports')}
          </strong>
        </TableCell>
        <TableCell align="center">
          <Box display="flex" justifyContent="center">
            <strong>{t('restrictions.rules')}</strong>
            <Tooltip arrow title={`${t('labels.options')}`}>
              <IconButtonBg
                sx={{ borderRadius: '6px', marginLeft: 2 }}
                size="small"
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <MoreVert fontSize="inherit" />
              </IconButtonBg>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        extraOptions={
          <Box>
            <MenuItem key="select" onClick={() => handleSelectAll()}>
              <ListItemText primary={t('labels.selectAll')} />
            </MenuItem>
            <MenuItem key="unselect" onClick={() => handleUnselectAll()}>
              <ListItemText primary={t('labels.unSelectAll')} />
            </MenuItem>
          </Box>
        }
      />
    </TableHead>
  )
}

export default HeadTableRestrictions
